import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ChatState } from '@lib/chat/models/chat.state.interface';

export const selectChatFeature = createFeatureSelector<ChatState>('chat');

export const selectChatDrafts = createSelector(selectChatFeature, (state: ChatState) => state.chatDrafts);

export const selectChatDraftsMap = createSelector(selectChatDrafts, chatDrafts => {
  const draftsMap = new Map<string, boolean>();
  chatDrafts.forEach(draft => {
    if (draft.message.trim().length > 0) {
      draftsMap.set(draft.threadId, true);
    }
  });
  return draftsMap;
});
